import React, { useState, useContext } from "react";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedOutlinedIcon from "@material-ui/icons/RadioButtonCheckedOutlined";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined";
import Chip from "@material-ui/core/Chip";

import TableContext from "../../context/table/tableContext";
import useMediaQuery from "../../hooks/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  dataViewFilterContainer: {
    marginTop: "10px",
  },
  dataViewFilterLabel: {
    fontSize: "14px",
    color: "#414141",
    font: "Bold 14px/16px Roboto;",
    letterSpacing: "0px",
    opacity: 1,
  },
  containerCheckbox: {
    display: "flex",
    marginTop: "15px",
  },
  labelCheckbox: {
    fontSize: "14px",
    marginTop: "2px",
  },
}));

const FiltersShiftClosures = (props) => {
  const tableContext = useContext(TableContext);
  const { setFilter, filters } = tableContext;
  const { terminals } = props;

  const classes = useStyles();
  const [forDay, setForDay] = useState(true);
  const [forTicket, setForTicket] = useState(false);
  const [search, setSearch] = useState(filters.filter || "");
  const [dates, setDates] = useState({
    dateFrom: !filters.dateFrom ? "" : filters.dateFrom,
    dateTo: !filters.dateTo ? "" : filters.dateTo,
  });

  const handleChangeCheckbox = (e) => {
    if (e.target.name === "forDay") {
      setForDay(e.target.checked);
      setForTicket(false);
    }
    if (e.target.name === "forTicket") {
      setForTicket(e.target.checked);
      setForDay(false);
    }
  };

  const onChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const onChangeDate = (e) => {
    setDates({
      ...dates,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };

  const onClickTerminal = (terminal) => {
    setFilter("terminal", terminal);
  };

  const { dateFrom, dateTo } = dates;

  const appliedDateFilter = () => {
    if (dateFrom) {
      setFilter("dateFrom", moment(dateFrom).format("DD-MM-YYYY"));
    }
    if (dateTo) {
      setFilter("dateTo", moment(dateTo).format("DD-MM-YYYY"));
    }
  };

  const isTablet = useMediaQuery("max-width", 1100);
  const isMobile = useMediaQuery("max-width", 600);

  const entries = Object.entries(filters);

  return (
    <div>
      <Grid>
        <div style={{ marginTop: "25px" }}>
          <TextField
            id="outlined-search"
            type="search"
            variant="outlined"
            placeholder="Nombre, numero, codigo.."
            value={search}
            onChange={onChangeSearch}
            style={{
              width: "90%",
              backgroundColor: "white",
            }}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon
                  style={{ color: "#707070" }}
                  position="end"
                  onClick={() => setFilter("filter", search)}
                ></SearchOutlinedIcon>
              ),
            }}
          />
        </div>
        <div style={{ display: "block", marginTop: "10px", height: "5%" }}>
          <div style={{ display: "flex" }}>
            <FilterListOutlinedIcon style={{ color: "#707070" }} />
            <Typography className={classes.labelCheckbox}>
              Filtros aplicados
            </Typography>
          </div>

          <div style={{ width: "180px" }}>
            {entries.map((entry, index) => {
              if (entry[1] && entry[0] !== "applied") {
                if (
                  entry[0] === "filter" ||
                  entry[0] === "terminal" ||
                  entry[0] === "dateFrom" ||
                  entry[0] === "dateTo"
                ) {
                  return (
                    <Chip
                      key={index}
                      label={entry[1]}
                      clickable
                      color="primary"
                      style={{ marginLeft: "10px", marginTop: "10px" }}
                      onClick={() => {
                        if (entry[0] === "filter") {
                          setSearch("");
                        }
                        if (entry[0] === "dateFrom") {
                          setDates({
                            ...dates,
                            dateFrom: "",
                          });
                        }
                        if (entry[0] === "dateTo") {
                          setDates({
                            ...dates,
                            dateTo: "",
                          });
                        }
                        setFilter(entry[0], "");
                      }}
                      /* deleteIcon={<DoneIcon />} */
                    />
                  );
                }
              }
            })}
          </div>
        </div>
        <div style={{ marginTop: "10%" }}>
          <Typography className={classes.dataViewFilterLabel}>Fecha</Typography>
          <div style={{ height: "60px", marginTop: "20px" }}>
            <input
              type="text"
              placeholder="Desde"
              name="dateFrom"
              value={dateFrom}
              style={{ width: !isMobile ? "150px" : "90px", height: "32px" }}
              onFocus={(e) => (e.currentTarget.type = "date")}
              onChange={onChangeDate}
            />
            <input
              type="text"
              placeholder="Hasta"
              name="dateTo"
              value={dateTo}
              style={{
                width: !isMobile ? "150px" : "90px",
                height: "32px",
                marginLeft: !isTablet || isMobile ? "3%" : "0px",
              }}
              onFocus={(e) => (e.currentTarget.type = "date")}
              onChange={onChangeDate}
            />
            <Fab
              size="small"
              aria-label="add"
              style={{
                backgroundColor: "#12b1ee",
                marginLeft: "8px",
                marginTop: isTablet ? "2%" : "0%",
              }}
              onClick={appliedDateFilter}
            >
              <ArrowForwardIosOutlinedIcon style={{ color: "white" }} />
            </Fab>
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Typography className={classes.dataViewFilterLabel}>
            Dispositivo asociado
          </Typography>
          <div
            style={{
              height: "100px",
              width: "200px",
              overflowY: "scroll",
              marginTop: "20px",
              display: "inline-grid",
            }}
          >
            {terminals.map((terminal, index) => (
              <span
                key={index}
                value={terminal}
                style={{ cursor: "pointer" }}
                onClick={() => onClickTerminal(terminal)}
              >
                {terminal}
              </span>
            ))}
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default FiltersShiftClosures;
